export function detectWVUSEnvUrl(urlStr = (window.WVUS_ENV_VARS && window.WVUS_ENV_VARS.urls && window.WVUS_ENV_VARS.urls.core || window.location.host)) {
    for (const [env,pattern] of Object.entries({
      "qa": /qa.worldvision/,
      "uat": /uat.worldvision/,
      "local": /local.worldvision/,
      "dev": /dev.worldvision/
    })) {
      if (pattern.test(urlStr)) {
        return env;
      }
    }
  
    return "prod";
  }

export function requiredParamsProvided(providedParams, requiredParams) {
    return (requiredParams.every(function(val) { return providedParams.indexOf(val) >= 0; }));
}

export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}